@if (this.authService.isAdmin()) {
  <div>
    <div class="filter-container">
      <div class="row">
        <div class="col-3 date-main pl-0 mr-0 pr-0">
          <div class="col-3 pl-0 ml-0">
            <p class="filter-item-date pl-0 ml-0">
              <button id="refresh" (click)="onClick()" class="button search-btn ml-3">
                {{'' | i18n: 'export'}}
              </button>
            </div>
          </div>
          <div>
            <p>{{'' | i18n: fullExportResponse }}</p>
            @if (fullExportError) {
              <p>{{'' | i18n: fullExportError }}</p>
            }
          </div>
        </div>
      </div>
    </div>
  }
